import React from 'react';

import { useSelector } from 'react-redux';

import universityDefaultAvatar from '../../assets/img/university_default_avatar.jpeg';
import { Image } from 'antd';

const InstitutionLogoHeader = ({ optionsDropdown }) => {
    const widget = useSelector((state) => state.widget);

    const logo = widget?.institution?.website_url;

    return (
        <div className="institution-logo-header-container">
            {logo ? (
                <a href={logo} target="_blank" rel="noopener noreferrer" aria-label="Navigate to the website">
                    <Image
                        className="institution-logo-header-container-image"
                        src={
                            widget?.institution?.avatar?.sizes['70x70'] ||
                            widget?.institution?.avatar?.original ||
                            universityDefaultAvatar
                        }
                        alt={'Logo'}
                    />
                </a>
            ) : (
                <div>
                    <Image
                        className="institution-logo-header-container-image"
                        src={
                            widget?.institution?.avatar?.sizes['70x70'] ||
                            widget?.institution?.avatar?.original ||
                            universityDefaultAvatar
                        }
                        alt={'Logo'}
                    />
                </div>
            )}
            <div className="institution-logo-header-divider" />
            {logo ? (
                <a
                    className="institution-logo-header-name"
                    href={logo}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Navigate to the website"
                >
                    {widget?.institution?.name}
                </a>
            ) : (
                <div className="institution-logo-header-name">{widget?.institution?.name}</div>
            )}
            {optionsDropdown}
        </div>
    );
};

export default InstitutionLogoHeader;
